var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-video"},[_c('div',{staticClass:"mod-shop-video"},[_c('div',{staticClass:"view-video"},[(_vm.content.img != '')?_c('img',{attrs:{"src":_vm.img}}):_c('img',{attrs:{"src":"https://dshop-static.tsphp.com/applet_mch/images/icon-bg3.jpg"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }